document.addEventListener("DOMContentLoaded", () => {
	const tabGroup = document.querySelector(".wp-block-plaudit-tab-content-group");

	if (!tabGroup) return;

	const tabs = Array.from(tabGroup.querySelectorAll<HTMLElement>(".tabContent"));
	const tabNav = document.createElement("ul");
	tabNav.className = "tab-nav";
	tabNav.setAttribute("role", "tablist");

	tabs.forEach((tab, index) => {
		const heading = tab.querySelector<HTMLElement>(".tabContent__heading");
		const content = tab.querySelector<HTMLElement>(".tabContent__content");

		if (!heading || !content) return;

		const li = document.createElement("li");
		const tabAnchor = document.createElement("a");
		tabAnchor.href = "#";
		tabAnchor.innerText = heading.innerText;
		tabAnchor.className = "tab-button";
		tabAnchor.setAttribute("role", "tab");
		tabAnchor.setAttribute("aria-selected", index === 0 ? "true" : "false");
		tabAnchor.setAttribute("tabindex", "0");

		if (index === 0) {
			content.style.display = "block";
			tabAnchor.classList.add("active");
		} else {
			content.style.display = "none";
		}

		tabAnchor.addEventListener("click", (e) => {
			e.preventDefault();

			tabs.forEach((otherTab, i) => {
				const otherContent = otherTab.querySelector<HTMLElement>(".tabContent__content");
				const otherAnchor = tabNav.querySelectorAll("a")[i];

				if (otherContent) {
					otherContent.style.display = "none";
				}

				otherAnchor.setAttribute("aria-selected", "false");
				otherAnchor.classList.remove("active");
			});

			content.style.display = "block";
			tabAnchor.setAttribute("aria-selected", "true");
			tabAnchor.classList.add("active");
			tabAnchor.focus();
		});

		li.appendChild(tabAnchor);
		tabNav.appendChild(li);
		heading.remove();
	});

	tabGroup.insertBefore(tabNav, tabGroup.firstChild);
	tabGroup.classList.remove("is-hidden");
});
